import invokeDialog from '@/components/services/dialog/invokeDialog';

export default invokeDialog;
